import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

const DownloadFile = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      fontSize='inherit'
      viewBox='0 0 11 11'
    >
      <svg
        fill='none'
        height='11'
        viewBox='0 0 11 11'
        width='11'
        xmlns='http://www.w3.org/2000/svg'
      >
        <path
          d='M1.33333 10.6667C0.966667 10.6667 0.652889 10.5362 0.392 10.2753C0.130667 10.014 0 9.7 0 9.33333V7.33333H1.33333V9.33333H9.33333V7.33333H10.6667V9.33333C10.6667 9.7 10.5362 10.014 10.2753 10.2753C10.014 10.5362 9.7 10.6667 9.33333 10.6667H1.33333ZM5.33333 8L2 4.66667L2.93333 3.7L4.66667 5.43333V0H6V5.43333L7.73333 3.7L8.66667 4.66667L5.33333 8Z'
          fill='#E84E0F'
        />
      </svg>
    </SvgIcon>
  );
};

export default DownloadFile;
